import { ptBR, en } from '@meta-awesome/i18n'
import I18n, { I18nProvider, useT, withT } from '@meta-react/i18n'

import localDe from './translations/de'
import localEnUS from './translations/en-US'
import localPtBR from './translations/pt-BR'

const dictionaries = {
  'de': { ...localDe },
  'pt': { ...ptBR, ...localPtBR },
  'en': { ...en, ...localEnUS }
}

export {
  dictionaries,
  I18nProvider,
  useT,
  withT
}

export default I18n
